import { render, staticRenderFns } from "./MapBuffer.vue?vue&type=template&id=40b2712c"
import script from "./MapBuffer.vue?vue&type=script&lang=js"
export * from "./MapBuffer.vue?vue&type=script&lang=js"
import style0 from "./MapBuffer.vue?vue&type=style&index=0&id=40b2712c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports